export const msToTime = (duration) => {
  let
    seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = (hours < 10) ? `0${hours}` : hours;
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  seconds = (seconds < 10) ? `0${seconds}` : seconds;
  return hours === '00' ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`;
};

export const encodeToUrlParams = (obj) => {
  if (obj instanceof String) {
    return obj;
  }
  const queryString = Object.keys(obj)
    .reduce((a, k) => {
      a.push(`${k}=${encodeURIComponent(obj[k])}`);
      return a;
    }, []).join('&');
  return `${queryString}`;
};

export const extractDomainFromString = (url) => {
  let a = document.createElement('a');
  a.href = decodeURIComponent(url);
  console.log(a);
  return a.hostname;
};
